module.exports = __webpack_public_path__ + "img/ic-chev-s.64dcd8b3.svg";